import type { RouteConfig } from 'vue-router'

export const routes: RouteConfig[] = [
  {
    path: '/master/packing',
    name: 'packing',
    component: () => import('@/pages/Master/Packing/index.vue'),
    meta: {
      requiresAuth: true,
      job_code: '069'
    }
  },
  {
    path: '/master/grade',
    name: 'grade',
    component: () => import('@/pages/Master/Grade/index.vue'),
    meta: {
      requiresAuth: true,
      job_code: '070'
    }
  },
  {
    path: '/master/login',
    name: 'login',
    component: () => import('@/pages/Master/Login/index.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/master/rank',
    name: 'rank',
    component: () => import('@/pages/Master/Rank/index.vue'),
    meta: {
      requiresAuth: true,
      job_code: '071'
    }
  },
  {
    path: '/master/setting',
    name: 'setting',
    component: () => import('@/pages/Master/Setting/index.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      job_code: '072'
    }
  },
  {
    path: '/master/shipper',
    name: 'shipper',
    component: () => import('@/pages/Master/Shipper/index.vue'),
    meta: {
      requiresAuth: true,
      job_code: '073'
    }
  },
  {
    path: '/master/supplier',
    name: 'supplier',
    component: () => import('@/pages/Master/Supplier/index.vue'),
    meta: {
      requiresAuth: true,
      job_code: '074'
    }
  },
  {
    path: '/master/member',
    name: 'member',
    component: () => import('@/pages/Master/Member/index.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      job_code: '075'
    }
  },
  {
    path: '/master/buyer',
    name: 'buyer',
    component: () => import('@/pages/Master/Buyer/index.vue'),
    meta: {
      requiresAuth: true,
      job_code: '076'
    }
  },
  {
    path: '/master/items',
    name: 'items',
    component: () => import('@/pages/Master/Item/index.vue'),
    meta: {
      requiresAuth: true,
      job_code: '076'
    }
  },
  {
    path: '/master/varieties',
    name: 'varieties',
    component: () => import('@/pages/Master/Variety/index.vue'),
    meta: {
      requiresAuth: true,
      job_code: '077'
    }
  },
  {
    path: '/master/calendar',
    name: 'calendar',
    component: () => import('@/pages/Master/Calendar/index.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      job_code: '080'
    }
  },
  {
    path: '/master/partner',
    name: 'partner',
    component: () => import('@/pages/Master/Partner/index.vue'),
    meta: {
      requiresAuth: true,
      job_code: '081'
    }
  },
  {
    path: '/master/file-management',
    name: 'file_management',
    component: () => import('@/pages/Master/FileManagement/index.vue'),
    meta: {
      requiresAuth: true,
      job_code: '082'
    }
  }
]
